import { ICreateChecklistServicoLiberacaoUseCase } from "../../../presentation/useCases/create/create_checklist_servico_liberacao_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateChecklistServicoLiberacaoUseCase
 */

export class CreateChecklistServicoLiberacaoUseCase implements ICreateChecklistServicoLiberacaoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServico: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.createChecklistServicoLiberacao(
      idChecklistServico,
      ordem,
      descricao,
    );
  }
}
